module.exports = __webpack_public_path__ + "static/media/4pic.6f8b3e36.jpg";